export const CITY_TYPES = {
  0: 'Campamento',
  1: 'Pueblo',
  2: 'Ciudad',
  3: 'Capital'
};

export const ITEM_TYPE_LABELS = {
  0: 'Arma',
  1: 'Kit',
  2: 'Munición',
  3: 'Objeto',
  4: 'Especial',
  5: 'Metal',
  6: 'Madera',
  7: 'Explosivo',
  8: 'Motor',
  9: 'Radar',
  10: 'Mochila',
  11: 'Guerra electronica',
  12: 'Bateria',
  13: 'Verdura / Cultivo',
  14: 'Semilla',
  15: 'Edificio / Estructura'
};

export const NEUTRAL_CLAN_IDS = new Set([0, 1]);
export const CITY_SHOP_RESTRICTED_ITEM_TYPES = new Set([5, 6, 13, 14]);
const WORKSHOP_REPAIR_PARTS = [
  { key: 'head', label: 'Cabeza', field: 'v_head', max: 20 },
  { key: 'torso', label: 'Torso', field: 'v_torso', max: 40 },
  { key: 'shoulderLeft', label: 'Hombro izquierdo', field: 'p_shoulder_l', max: 30 },
  { key: 'shoulderRight', label: 'Hombro derecho', field: 'p_shoulder_r', max: 30 },
  { key: 'armLeft', label: 'Brazo izquierdo', field: 'v_arm_l', max: 20 },
  { key: 'armRight', label: 'Brazo derecho', field: 'v_arm_r', max: 20 },
  { key: 'legLeft', label: 'Pierna izquierda', field: 'v_leg_l', max: 30 },
  { key: 'legRight', label: 'Pierna derecha', field: 'v_leg_r', max: 30 }
];

export function isNeutralClanId(clanId) {
  return NEUTRAL_CLAN_IDS.has(Number(clanId || 0));
}

export function isWeaponOrAmmoType(itemType) {
  const type = Number(itemType);
  return type === 0 || type === 2;
}

export function isAirTransportCity(city) {
  const type = Number(city?.city_type ?? -1);
  return type === 2 || type === 3;
}

export function hasMinimumDepartureLoadout(payload) {
  const rows = Array.isArray(payload?.items) ? payload.items : [];
  const equipped = payload?.equipped || {};
  const accessories = payload?.accessories || {};

  const weaponCount = rows
    .filter((row) => Number(row.item_type) === 0)
    .reduce((sum, row) => sum + Number(row.quantity || 0), 0);

  const ammoMagazines = rows
    .filter((row) => Number(row.item_type) === 2)
    .reduce((sum, row) => sum + Number(row.quantity || 0), 0);

  const medkits = rows
    .filter((row) => Number(row.item_type) === 1)
    .reduce((sum, row) => sum + Number(row.quantity || 0), 0);

  const equippedWeaponSlots = Object.values(equipped).filter((item) => item && Number(item.item_type) === 0).length;
  const activeBackpack = Boolean(accessories.backpack);
  const activeBattery = Boolean(accessories.battery);
  const activeRadar = Boolean(accessories.radar);

  const missing = [];
  if (weaponCount <= 0 && equippedWeaponSlots <= 0) missing.push('1 arma');
  if (ammoMagazines <= 0) missing.push('1 cargador de munición');
  if (medkits <= 0) missing.push('1 kit médico');
  if (!activeBackpack) missing.push('1 mochila activa');
  if (!activeBattery) missing.push('1 batería activa');

  return {
    weaponCount,
    ammoMagazines,
    medkits,
    equippedWeaponSlots,
    activeBackpack,
    activeBattery,
    activeRadar,
    missing,
    canLeave: missing.length === 0
  };
}

export function getCityAccessForBot(bot, city) {
  if (!city || !bot) {
    return {
      isGuestInForeignClanCity: false,
      canBuyWeaponsAmmo: true,
      canUseWorkshop: true,
      canUseTransport: isAirTransportCity(city),
      canUseHangar: true,
      canUseWarehouse: true,
      canUseLand: true,
      entryFeeRequired: false,
      entryFeeMax: 5
    };
  }

  const neutralPilot = isNeutralClanId(bot?.clan);
  const neutralCity = isNeutralClanId(city?.clan);
  const isGuestInForeignClanCity = neutralPilot && !neutralCity;

  return {
    isGuestInForeignClanCity,
    canBuyWeaponsAmmo: !isGuestInForeignClanCity,
    canUseWorkshop: true,
    canUseTransport: isAirTransportCity(city),
    canUseHangar: !isGuestInForeignClanCity,
    canUseWarehouse: !isGuestInForeignClanCity,
    canUseLand: !isGuestInForeignClanCity,
    entryFeeRequired: isGuestInForeignClanCity,
    entryFeeMax: 5
  };
}

export function getWorkshopRepairOptions(bot, unitCost = 1) {
  return WORKSHOP_REPAIR_PARTS.map((part) => {
    const current = Number(bot?.[part.field] || 0);
    const max = Number(part.max || 0);
    const damage = Math.max(0, max - current);

    return {
      ...part,
      current,
      max,
      damage,
      cost: Math.max(0, damage * Number(unitCost || 1))
    };
  });
}

export function getGalleryImageSrc(entity) {
  const filename = String(entity?.image || '').trim();
  if (!filename || filename === 'default.png') return '';
  const apiBase = import.meta.env.VITE_API_URL || '';
  return `${apiBase}/uploads/gallery/${filename}`;
}
